export default [
  // Centers
  {
    path: "/05097b37cac61faad9e752b8",
    children: [
      {
        path: "sDPI004e06e42acdecc10bcb49d83HF48",
        name: "saiqe26.centers",
        meta: {
          title: "SAIQE 2026 centers",
          authRequired: true,
          acc: ["y56416"],
        },
        component: () => import("@/views/saiqe/tws/center_management/index.vue"),
      },
      // view center
      {
        path: "kUD0522c3de1b98ed0a3048a055qTla/:cn?",
        name: "saiqe26.center.view",
        meta: {
          title: "View SAIQE 2026 center",
          authRequired: true,
          acc: ["y91180"],
        },
        component: () => import("@/views/saiqe/tws/center_management/view.vue"),
      },
        // assign center
       {
        path: "w2c06a9b55438fa7665298cca9b2413f",
        name: "saiqe26.center.create",
        meta: {
          title: "Create SAIQE 2026 center",
          authRequired: true,
          acc: ["y20941"],
        },
        component: () => import("@/views/saiqe/tws/center_management/create.vue"),
      },
      //   {
      //     path: "hgnerugervbhoiuvervgye",
      //     name: "newCenters",
      //     meta: {
      //       title: "2025 QE NEW CENTERS",
      //       authRequired: true,
      //       acc: ["y99931"],
      //     },
      //     component: () =>
      //       import("../views/qe/twf/center_management/newCenters.vue"),
      //   },
      //   {
      //     path: "center_requests",
      //     name: "newCenterRequest",
      //     meta: {
      //       title: "2025 QE NEW CENTERS Requests",
      //       authRequired: true,
      //       acc: ["y99931"],
      //     },
      //     component: () =>
      //       import("../views/qe/twf/center_management/requests.vue"),
      //   },
      //   {
      //     path: "center_request/:cn?",
      //     name: "CenterRequestv",
      //     meta: {
      //       title: "2025 QE Requests Details",
      //       authRequired: true,
      //       acc: ["y99931"],
      //     },
      //     component: () =>
      //       import("../views/qe/twf/center_management/request.vue"),
      //   },
      //   {
      //     path: ":cn/edit_center",
      //     name: "editCenter",
      //     meta: {
      //       title: "EDIT CENTERS",
      //       authRequired: true,
      //       acc: ["y99931"],
      //     },
      //     component: () =>
      //       import("../views/qe/twf/center_management/edit-center.vue"),
      //   },
    ],
  },
];
